<nb-card>
	<nb-card-header>
		<span *ngIf="!team">
			{{ 'FORM.LABELS.ADD_TEAM' | translate }}
		</span>
		<span *ngIf="team">
			{{ 'FORM.LABELS.EDIT_TEAM' | translate }}
		</span>
	</nb-card-header>

	<nb-card-body>
		<form>
			<div class="row">
				<div class="form-group col-6">
					<label class="label">{{
						'FORM.PLACEHOLDERS.TEAM_NAME' | translate
					}}</label>
					<input
						type="text"
						[(ngModel)]="name"
						[ngModelOptions]="{ standalone: true }"
						nbInput
						fullWidth
						placeholder="{{
							'FORM.PLACEHOLDERS.TEAM_NAME' | translate
						}}"
					/>
				</div>
				<div class="form-group col-6">
					<ga-tags-color-input
						[selectedTags]="tags"
						(selectedTagsEvent)="selectedTagsEvent($event)"
						[isOrgLevel]="true"
					>
					</ga-tags-color-input>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-6">
					<label class="label">{{
						'FORM.LABELS.ADD_REMOVE_MEMBERS' | translate
					}}</label>
					<nb-select
						multiple
						[selected]="selectedEmployees"
						(selectedChange)="onMembersSelected($event)"
						fullWidth
						placeholder="{{
							'FORM.PLACEHOLDERS.ADD_REMOVE_MEMBERS' | translate
						}}"
					>
						<nb-option
							*ngFor="let employee of employees"
							[value]="employee.id"
						>
							<img
								src="{{ employee.user.imageUrl }}"
								alt="Smiley face"
								height="40"
								width="40"
								style="margin-right: 10px"
							/>
							{{ employee.user.firstName }}
							{{ employee.user.lastName }}</nb-option
						>
					</nb-select>
				</div>
				<div class="form-group col-6">
					<label class="label">{{
						'FORM.LABELS.ADD_REMOVE_MANAGERS' | translate
					}}</label>
					<nb-select
						multiple
						[selected]="selectedManagers"
						(selectedChange)="onManagersSelected($event)"
						fullWidth
						placeholder="{{
							'FORM.PLACEHOLDERS.ADD_REMOVE_MANAGERS' | translate
						}}"
					>
						<nb-option
							*ngFor="let manager of employees"
							[value]="manager.id"
						>
							<img
								src="{{ manager.user.imageUrl }}"
								alt="Smiley face"
								height="40"
								width="40"
								style="margin-right: 10px"
							/>
							{{ manager.user.firstName }}
							{{ manager.user.lastName }}</nb-option
						>
					</nb-select>
				</div>
			</div>
		</form>
		<div
			class="form-group"
			style="
				display: flex;
				flex-direction: row;
				justify-content: flex-end;
			"
		>
			<button (click)="cancel()" nbButton status="danger" class="mr-2">
				{{ 'BUTTONS.CANCEL' | translate }}
			</button>
			<button (click)="addOrEditTeams()" nbButton status="success">
				{{ 'BUTTONS.SAVE' | translate }}
			</button>
		</div>
	</nb-card-body>
</nb-card>
